<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-yqtsz__ruleconfigtable">
      <el-tabs v-model="activeName"  @tab-click="handleClick" >
        <el-tab-pane  label="特色章" name="basic">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          </el-form>
          <el-row>
            <el-col :span="5" v-for="o in dataList" style="margin: auto;margin-left: 30px" :key="o.id" >
              <el-card  style="background-color: #D7EBF9" :body-style="{ padding: '0px' }">
                <div>
                  <h3 style="color: #438CF0;text-align: center;font-weight: bolder">{{o.ruleConfigTable}}</h3>
                  <h4 style="color: #438CF0;text-align: center">包含年级：<span style="margin-left: 5px" :key="o.gradeId">{{o.gradeName}}</span></h4>
                  <div class="bottom clearfix" style="font-size:0;font-weight: bolder">
                    <el-button size="small" style="font-weight: bolder" @click="addOrUpdateHandle(o.id)" class="button"><i class="el-icon-edit"></i>修改</el-button>
                    <el-button size="small" style="font-weight: bolder" @click="configHandle(o)" class="button"><i class="el-icon-setting"></i>设置</el-button>
                    <el-button size="small" style="font-weight: bolder" @click="deleteRuleTable(o.id)" class="button"><i class="el-icon-delete"></i>删除</el-button>
                    <el-button v-if="o.isAllLife === 1" size="small" style="font-weight: bolder" @click="openAllLifeSpecial(o)" class="button"><i class="el-icon-delete"></i>开启</el-button>
                    <el-button v-if="o.isOpened === 1" size="small" style="font-weight: bolder" @click="addNewStudentAllLifeSpecial(o)" class="button"><i class="el-icon-delete"></i>添加新学生</el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="5" @click="addOrUpdateHandle()" style="height: 170px;line-height: 170px;font-size: 34px;text-align: center;background-color: #FFFFFF">
              <el-card @click.native="addOrUpdateHandle()" style="margin-left: 30px" shadow="always" :body-style="{ padding: '0px' }">
                <i @click="addOrUpdateHandle()" class="el-icon-plus" ></i>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getRuleList"></add-or-update>
      <rule-decoration v-if="configVisible" ref="ruleDecoration" @refreshDataList="getRuleList"></rule-decoration>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './ruleconfigtable-add-or-update'
import RuleDecoration from './ruledecoration'
import { Loading, MessageBox } from 'element-ui'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/yqtsz/ruleConfigTable/page',
        getDataListIsPage: false,
        exportURL: '/yqtsz/ruleConfigTable/export',
        deleteURL: '/yqtsz/ruleConfigTable',
        deleteIsBatch: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      dataList: [],
      configVisible: false,
      activeName: 'basic',
      dataForm: {
      }
    }
  },
  watch: {
  },
  mounted () {
    this.getRuleList()
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    deleteRuleTable (id) {
      this.$confirm(this.$t('prompt.info', { handle: this.$t('delete') }), '是否确认删除规则配置表', {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http.post('/yqtsz/ruleConfigTable/deleteRuleConfigTable/' + id).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.getRuleList()
          this.$notify({
            type: 'info',
            duration: '750',
            message: '规则配置表删除成功'
          })
        })
      })
    },
    configHandle (row) {
      this.configVisible = true
      this.$nextTick(() => {
        this.$refs.ruleDecoration.dataForm.tableId = row.id
        this.$refs.ruleDecoration.dataForm.ruleConfigTable = row.ruleConfigTable
        this.$refs.ruleDecoration.dataForm.gradeId = row.gradeId
        this.$refs.ruleDecoration.dataForm.isAllLife = row.isAllLife
        this.$refs.ruleDecoration.init()
      })
    },
    // 获取规则配置表
    getRuleList () {
      this.$http.get('yqtsz/ruleConfigTable/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataList = res.data
        console.log(res.data)
      })
    },
    // 开启全生涯特色章
    openAllLifeSpecial (row) {
      // 先判断是否已经开启过了特色章
      if (row.isOpened === 1) {
        return this.$message.error('该章已经开启，无法再开启！')
      }
      const loadingInstance = Loading.service({ text: '数据量大,请稍后...' })
      this.$http.post('yqtsz/ruleConfigTable/openAllLifeSpecial', row).then(({ data: res }) => {
        loadingInstance.close()
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.getRuleList()
      })
    },
    addNewStudentAllLifeSpecial (row) {
      return MessageBox.confirm('是否添加一年级学生的特色章', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(res => {
        const loadingInstance = Loading.service({ text: '数据量大,请稍后...' })
        this.$http.post('yqtsz/ruleConfigTable/openAllLifeSpecial', row).then(({ data: res }) => {
          loadingInstance.close()
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.getRuleList()
        })
      }).catch(err => {
        console.log('err', err)
      })
    }
  },
  components: {
    RuleDecoration,
    AddOrUpdate
  }
}
</script>
